const BaseInfoView = ({ retailer }) => {
  const isAgent = retailer.user.groups.some(
    (group) => group.name === "Retailer Agent",
  );

  return (
    <table>
      <tbody>
        <tr>
          <td>
            <label htmlFor="">Company: </label>
          </td>
          <td className="w-full">{retailer.company}</td>
        </tr>
        <tr>
          <td>
            <label htmlFor="">Is Agent: </label>
          </td>
          <td>{isAgent ? "Yes" : "No"}</td>
        </tr>

        <tr>
          <td>
            <label htmlFor="">Belong to Agent: </label>
          </td>
          <td>{retailer.belongToAgentUser?.email || "-"}</td>
        </tr>

        <tr>
          <td>
            <label htmlFor="">Discount on Prepaid: </label>
          </td>
          <td>{retailer.discountOnPrepaid ? "Yes" : "No"}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default BaseInfoView;
